const adapter = [
  {
    path: '/adapter/mini-program-send-sms',
    name: '就诊顾问',
    component: () => import('@/pages/adapter/mini-program-send-sms')
  },
];

export default adapter;
